interface RxBlobImageViewerProps {
	image: Blob;
	alt: string;
	className?: string;
	height?: string;
}

const RxBlobImageViewer = (props: RxBlobImageViewerProps) => {
	return (
		<img
			src={"data:image/png;base64," + props.image}
			className={props.className}
			alt={props.alt}
			height={props.height}
		/>
	);
};

export default RxBlobImageViewer;
